import { ReactNode } from "react";

export type FooterProps = { children: ReactNode };

export const Footer = ({ children }: FooterProps) => {
  return (
    <footer className="bg-surface-emphasis px-4 py-8 text-white lg:p-12">
      {children}
    </footer>
  );
};
